import { combineReducers } from "redux";

import payrollSchedule from "./payrollSchedule";

const payrollCalendar = combineReducers({
  payrollSchedule
});

export default payrollCalendar;
